(function () {
  'use strict';

  /* @ngdoc object
   * @name crewingReport
   * @description
   *
   */
  angular
    .module('crewingReport', [
      'ui.router'
    ]);
}());
